export const GET_QUOTE = 'GET_QUOTE';
export const GET_QUOTE_SUCCESS = 'GET_QUOTE_SUCCESS';
export const GET_QUOTE_FAILED = 'GET_QUOTE_FAILED';
